exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EmptyList-noDataIconSec-QvkoF {\r\n    width: 184px;\r\n    height: 120px;\r\n}\r\n\r\n.EmptyList-noTransactionSectionSpace-2e7Us {\r\n    margin-top: 66px;\r\n    margin-bottom: 22px;\r\n}\r\n\r\n.EmptyList-noPayoutContentSection-30i3H {\r\n    max-width: 580px;   \r\n}\r\n\r\n@media screen and (max-width:767px) {\r\n    .EmptyList-noPayoutContentSection-30i3H {\r\n        max-width: 100%\r\n    }\r\n}", ""]);

// exports
exports.locals = {
	"noDataIconSec": "EmptyList-noDataIconSec-QvkoF",
	"noTransactionSectionSpace": "EmptyList-noTransactionSectionSpace-2e7Us",
	"noPayoutContentSection": "EmptyList-noPayoutContentSection-30i3H"
};